import lang from '../../lib/language';

import exclamationMark from '../../assets/img/icon-exclamation-mark-warning-big.svg';

import styles from './MaintenanceNotice.module.scss';

export const TRADE_SUPPORT_EMAIL = 'support@acetrade.com';

/**
 * Copy shown while the `maintenance` feature flag is on. Exported so the
 * transient top-of-page bar reuses it and the wording stays in one place.
 */
export const MaintenanceMessage = () => (
  <>
    <span>{`${lang.commonMaintenanceMessageBeforeEmail()} `}</span>
    <a className={styles.maintenanceEmail} href={`mailto:${TRADE_SUPPORT_EMAIL}`}>{TRADE_SUPPORT_EMAIL}</a>
    <span>{`. ${lang.commonMaintenanceMessageAfterEmail()}`}</span>
  </>
);

type Props = {
  className?: string;
};

/**
 * Persistent notice that takes the place of every Buy/Sell/Modify entry point
 * while the `maintenance` flag is on - see `useMaintenanceMode`.
 */
const MaintenanceNotice = ({ className }: Props) => (
  <div className={[ styles.maintenanceInfo, className ].filter(Boolean).join(' ')}>
    <div className={styles.icon}>
      <img id="MaintenanceAlertIcon" src={exclamationMark} alt="icon" />
    </div>
    <div className={styles.message}>
      <MaintenanceMessage />
    </div>
  </div>
);

export default MaintenanceNotice;
